import { useEffect, useState } from "react";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Packages from "@/components/Packages";
import Facilities from "@/components/Facilities";
import AIPlan from "@/components/AIPlan";
import Equipments from "@/components/Equipments";
import Franchise from "@/components/Franchise";
import Footer from "@/components/Footer";
import AdmissionModal from "@/components/AdmissionModal";
import OfferPopup from "@/components/OfferPopup";
import AIChat from "@/components/AIChat";
import WhatsAppFloat from "@/components/WhatsApp";
import api from "@/lib/api";

const Landing = () => {
  const [packages, setPackages] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSlug, setSelectedSlug] = useState(null);
  const [paymentsEnabled, setPaymentsEnabled] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    api.get("/packages").then((res) => setPackages(res.data)).catch(() => {});
    api.get("/payments/config").then((res) => setPaymentsEnabled(!!res.data.enabled)).catch(() => {});
  }, []);

  const openEnroll = (slug) => {
    setSelectedSlug(slug);
    setModalOpen(true);
  };

  return (
    <div data-testid="landing-page" className="min-h-screen bg-ink text-white">
      <Navbar onEnroll={openEnroll} />
      <Hero onEnroll={openEnroll} />
      <Marquee />
      <Packages packages={packages} onEnroll={openEnroll} />
      <Facilities />
      <AIPlan />
      <Equipments paymentsEnabled={paymentsEnabled} />
      <Franchise />
      <Footer onEnroll={openEnroll} />
      <AdmissionModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        packages={packages}
        selectedSlug={selectedSlug}
        paymentsEnabled={paymentsEnabled}
      />
      <WhatsAppFloat />
      <AIChat />
      <OfferPopup onEnroll={openEnroll} />
    </div>
  );
};

export default Landing;
